import purchaseOfferSushi from '@/components/purchase/sushi/purchase-offer-sushi/purchase-offer-sushi';
import marketCharts from '@/components/market/market-detail-charts/market-detail-charts.vue';
import purchaseTradeTypeSwitcherSushi from '@/components/purchase/sushi/purchase-trade-type-switcher-sushi/purchase-trade-type-switcher-sushi.vue';
import purchaseExtendedBetslip
  from '@/components/purchase/sushi/purchase-extended-betslip/purchase-extended-betslip.vue';

export default {
  mixins: [
    purchaseOfferSushi,
  ],
  components: {
    marketCharts,
    purchaseTradeTypeSwitcherSushi,
    purchaseExtendedBetslip,
  },
  computed: {
    chartOptions() {
      return {
        include24hr: true,
        include7day: true,
        include30day: true,
        include90day: true,
        includeCandle: true,
        includeLine: true,
        includeLegend: false,
        contractIds: [this.tradeOptions.contractId]
      }
    },
    mainClassName() {
      return 'purchase-offer-desktop-sushi';
    },
    classModifiers() {
      return {
        [this.mainClassName]: true,
        [`${this.mainClassName}--maintenance`]: !this.isTradingEnabled,
        [`${this.mainClassName}--yes`]: this.tradeOptions.operationValue === 'yes',
        [`${this.mainClassName}--no`]: this.tradeOptions.operationValue === 'no',
        [`${this.mainClassName}--${this.$router.currentRoute.name}`]: true,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-offer-desktop-sushi/purchase-offer-desktop-sushi.js